function formatId(id: string) {
  return id.replace(/\W/g, '').toUpperCase();
}

function buildBuildingId(propertyManagerId: string, propertyId: string) {
  console.log(`buildBuildingId: ${propertyManagerId}, ${propertyId}`);
  return `YARDI_${formatId(propertyManagerId)}_${formatId(propertyId)}`;
}

export { buildBuildingId };
